export default __webpack_public_path__ + "static/media/kenzieshop.ea70246b.png";